'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../utils');

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Can I add defaultProps to make the resolution of some of these dynamic styles
// any easier?
// see: https://stackoverflow.com/questions/45977114/using-proptypes-and-defaultprops-for-a-styled-component
var Cell = _styledComponents2.default.div.withConfig({
  displayName: 'Cell'
})(['box-sizing:border-box;display:', ';align-self:', ';', ';'], function (props) {
  return props.flexed ? 'flex' : 'block';
}, function (props) {
  return _utils.align[props.align];
}, function (props) {
  return props.width && props.width !== 'auto' ? widthMixins.custom : widthMixins.default;
});

Cell.propTypes = {
  align: _propTypes.string,
  children: _propTypes.node,
  flexed: _propTypes.bool,
  width: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.array])
};

var widthMixins = {
  default: '\n    width: auto;\n    flex: 1;\n  ',
  custom: (0, _styledComponents.css)(['', ';flex:none;'], function (props) {
    return (0, _utils.width)(props.width);
  })
};

exports.default = Cell;


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/components/Cell.js
// module id = 298
// module chunks = 4